import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { MICROSERVICES } from '@shared/constants/microservices';
import { Observable } from 'rxjs/internal/Observable';
import { VehicleResponse } from '../domain/vehicle.model';
import { CreateVehicleDto } from './dto/vehicle.dto';
import { VehiclesRepository } from './vehicles.repository';

@Injectable()
export class VehiclesApiService implements VehiclesRepository {
    private _http = inject(HttpClient);

    createVehicle(createVehicleDto: CreateVehicleDto): Observable<VehicleResponse> {
        return this._http.post<VehicleResponse>(`${environment.url}${MICROSERVICES.vehicles}/v1/vehicles`, createVehicleDto);
    }

    getVehicles(): Observable<VehicleResponse[]> {
        return this._http.get<VehicleResponse[]>(`${environment.url}${MICROSERVICES.vehicles}/v1/vehicles`);
    }

    getVehicle(vehicleId: string): Observable<VehicleResponse> {
        return this._http.get<VehicleResponse>(`${environment.url}${MICROSERVICES.vehicles}/v1/vehicles/${vehicleId}`);
    }

    deleteVehicle(vehicleId: string): Observable<void> {
        return this._http.delete<void>(`${environment.url}${MICROSERVICES.vehicles}/v1/vehicles/${vehicleId}`);
    }
}
